// Central runtime config, populated from build-time env vars (CRA REACT_APP_*).
// Set these in frontend/.env before `npm run build` (see README).
export const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  cognitoDomain: process.env.REACT_APP_COGNITO_DOMAIN, // e.g. https://horse-and-livestock.auth.us-west-2.amazoncognito.com
  clientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
  redirectUri: process.env.REACT_APP_REDIRECT_URI, // e.g. https://horse-and-livestock.sturgeon.tech/callback
  logoutUri: process.env.REACT_APP_LOGOUT_URI // e.g. https://horse-and-livestock.sturgeon.tech/
};
